module.exports = __webpack_public_path__ + "static/b2b-and-b2c-consulting-2ea3c6ebdc2c34c27a1daf313f8f29f8.jpg";